import React from 'react'

export default ({ children }) => {
  if (!children) return null
  return (
    <p className="signup-box__required">
      <i className="fa fa-exclamation-circle" />
      {children}
    </p>
  )
}
